export default __webpack_public_path__ + "static/media/home-3.e63bb501.png";